/**
 * External dependencies
 */
import React from "react";
import { map, find } from "lodash";

/**
 * Internal dependencies
 */
import DropdownLink from "components/dropdown-link";
import { Box, Text } from "@towersystems/towersystems-design-system";
import SchemeIcon from "./scheme-icon";
import { COLORS } from "./constants";
import useReportBuilder from "modules/report-builder/use-report-builder";

/**
 * Style dependencies
 */
import "./styles.scss";

const ColorSchemeDropdown = (props) => {
  const { editReport, report } = useReportBuilder();

  const selectedColor =
    find(COLORS, { id: report.config.colorTheme }) || COLORS[0];

  const label = (
    <Box display="flex" alignItems="flexBottom">
      <Box marginRight="small">Color scheme: </Box>
      <SchemeIcon
        color1={selectedColor.color1}
        color2={selectedColor.color2}
        color3={selectedColor.color3}
      />
    </Box>
  );

  const items = map(COLORS, (color) => {
    return {
      key: color.id,
      id: color.id,
      onClick: ({ id }) => editReport({ config: { colorTheme: id } }),
      label: (
        <Box display="flex" alignItems="center">
          <Box marginRight="large">
            <SchemeIcon
              color1={color.color1}
              color2={color.color2}
              color3={color.color3}
            />
          </Box>
          <Text>{color.label}</Text>
        </Box>
      ),
    };
  });

  return <DropdownLink label={label} items={items}></DropdownLink>;
};

export default ColorSchemeDropdown;
